import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-finance',
  templateUrl: './project-finance.component.html',
  styleUrls: ['./project-finance.component.css']
})
export class ProjectFinanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
